const SELECTED = "*";

export const setFlag = (data, rowKey, value) => {
	const indicator = value ? SELECTED : "";
	data.setCell("productExclusion", rowKey, 0, indicator, () => indicator);
};

export const setEveryFlag = (data, value) => {
	for (const { key } of data.curData.values.table.productExclusion.list)
		setFlag(data, key, value);
};

const findChildren = (rows, row) =>
	row.list[5].map((ck) => rows.find(({ key }) => key === ck));

export const setTreeFlags = (data, rows, row, value) => {
	setFlag(data, row.key, value);
	for (const cr of findChildren(rows, row)) setTreeFlags(data, rows, cr, value);
};

const updateParentFlags = (data, rows, row) => {
	const parent = rows.find(({ list }) => list[5].includes(row.key));
	if (!parent) return;
	const children = findChildren(rows, parent);
	const isAll = children.every(({ list }) => list[0] === SELECTED);
	setFlag(data, parent.key, isAll);
	updateParentFlags(data, rows, parent);
};

export const toggleFlag = (data, rows, row) => {
	const value = row.list[0] !== SELECTED;
	setTreeFlags(data, rows, row, value);
	updateParentFlags(data, rows, row);
};
